(function () {
  const STORAGE_KEY = 'jpArtworkSelection';

  function getSelection() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (error) {
      return [];
    }
  }

  function saveSelection(selection) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(selection));
  }

  function formatArtwork(artwork) {
    return [
      artwork.title,
      artwork.collection ? 'Coleção: ' + artwork.collection : '',
      artwork.year ? 'Ano: ' + artwork.year : '',
      artwork.technique ? 'Técnica: ' + artwork.technique : '',
      artwork.dimensions ? 'Dimensões: ' + artwork.dimensions : ''
    ].filter(Boolean).join('\n');
  }

  document.addEventListener('DOMContentLoaded', function () {
    const revealItems = document.querySelectorAll('.jp-reveal');

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.18 });

      revealItems.forEach(function (item) {
        observer.observe(item);
      });
    } else {
      revealItems.forEach(function (item) {
        item.classList.add('is-visible');
      });
    }

    const drawer = document.querySelector('[data-jp-drawer]');
    const overlay = document.querySelector('[data-jp-overlay]');
    const closeButtons = document.querySelectorAll('[data-jp-close]');
    const triggers = document.querySelectorAll('[data-artwork-trigger]');
    const floatingSelection = document.querySelector('[data-jp-floating-selection]');

    const drawerImageWrap = document.querySelector('[data-jp-drawer-image]');
    const drawerTitle = document.querySelector('[data-jp-drawer-title]');
    const drawerMeta = document.querySelector('[data-jp-drawer-meta]');
    const drawerModeLabel = document.querySelector('[data-jp-drawer-label]');
    const addButton = document.querySelector('[data-jp-add-selection]');
    const selectionList = document.querySelector('[data-jp-selection-list]');
    const form = document.querySelector('[data-jp-form]');
    const bodyField = document.querySelector('[data-jp-contact-body]');
    const commentField = document.querySelector('[data-jp-comment]');
    const status = document.querySelector('[data-jp-status]');

    let currentArtwork = null;
    let currentMode = 'artwork';

    function updateFloatingSelection() {
      if (!floatingSelection) return;

      const selection = getSelection();

      if (selection.length > 0) {
        floatingSelection.textContent = 'Minha seleção · ' + selection.length;
        floatingSelection.classList.add('is-visible');
      } else {
        floatingSelection.classList.remove('is-visible');
      }
    }

    function openDrawer() {
      if (!drawer || !overlay) return;
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
    }

    function closeDrawer() {
      if (!drawer || !overlay) return;
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      document.documentElement.style.overflow = '';
    }

    function getArtworkFromTrigger(trigger) {
      return {
        id: trigger.dataset.artworkId || '',
        title: trigger.dataset.artworkTitle || '',
        collection: trigger.dataset.artworkCollection || '',
        year: trigger.dataset.artworkYear || '',
        technique: trigger.dataset.artworkTechnique || '',
        dimensions: trigger.dataset.artworkDimensions || '',
        image: trigger.dataset.artworkImage || '',
        url: trigger.dataset.artworkUrl || ''
      };
    }

    function renderArtworkDrawer(artwork) {
      currentMode = 'artwork';
      currentArtwork = artwork;

      if (drawerModeLabel) drawerModeLabel.textContent = 'Consultar obra';
      if (drawerTitle) drawerTitle.textContent = artwork.title;

      if (drawerMeta) {
        drawerMeta.innerHTML = [
          artwork.collection ? '<div>' + artwork.collection + '</div>' : '',
          artwork.year ? '<div>' + artwork.year + '</div>' : '',
          artwork.technique ? '<div>' + artwork.technique + '</div>' : '',
          artwork.dimensions ? '<div>' + artwork.dimensions + '</div>' : ''
        ].filter(Boolean).join('');
      }

      if (drawerImageWrap) {
        drawerImageWrap.style.display = artwork.image ? 'block' : 'none';
        drawerImageWrap.innerHTML = artwork.image
          ? '<img src="' + artwork.image + '" alt="' + artwork.title.replace(/"/g, '&quot;') + '">'
          : '';
      }

      if (selectionList) {
        selectionList.classList.remove('is-visible');
        selectionList.innerHTML = '';
      }

      if (addButton) {
        addButton.style.display = 'block';
        addButton.textContent = 'Adicionar à minha seleção';
      }

      if (status) status.textContent = '';
      openDrawer();
    }

    function renderSelectionDrawer() {
      const selection = getSelection();

      currentMode = 'selection';
      currentArtwork = null;

      if (drawerModeLabel) drawerModeLabel.textContent = 'Minha seleção';
      if (drawerTitle) drawerTitle.textContent = 'Minha seleção';
      if (drawerMeta) drawerMeta.innerHTML = '';
      if (drawerImageWrap) {
        drawerImageWrap.style.display = 'none';
        drawerImageWrap.innerHTML = '';
      }

      if (addButton) {
        addButton.style.display = 'none';
      }

      if (selectionList) {
        selectionList.classList.add('is-visible');

        if (selection.length === 0) {
          selectionList.innerHTML = '<p>Sua seleção ainda está vazia. Ao navegar pelas coleções, você poderá reunir obras de interesse para enviar uma única consulta à galeria.</p>';
        } else {
          selectionList.innerHTML = selection.map(function (artwork) {
            return [
              '<div class="jp-selection-item" data-selection-id="' + artwork.id + '">',
                artwork.image ? '<img src="' + artwork.image + '" alt="">' : '<div></div>',
                '<div>',
                  '<strong>' + artwork.title + '</strong>',
                  '<small>' + [
                    artwork.collection,
                    artwork.year,
                    artwork.technique,
                    artwork.dimensions
                  ].filter(Boolean).join(' · ') + '</small>',
                  '<button type="button" class="jp-selection-remove" data-remove-selection="' + artwork.id + '">Remover</button>',
                '</div>',
              '</div>'
            ].join('');
          }).join('');
        }
      }

      if (status) status.textContent = '';
      openDrawer();
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        renderArtworkDrawer(getArtworkFromTrigger(trigger));
      });
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeDrawer);
    });

    if (overlay) {
      overlay.addEventListener('click', closeDrawer);
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeDrawer();
    });

    if (addButton) {
      addButton.addEventListener('click', function () {
        if (!currentArtwork) return;

        const selection = getSelection();
        const alreadyExists = selection.some(function (item) {
          return item.id === currentArtwork.id;
        });

        if (!alreadyExists) {
          selection.push(currentArtwork);
          saveSelection(selection);
          updateFloatingSelection();
          if (status) status.textContent = 'Obra adicionada à sua seleção.';
          addButton.textContent = 'Adicionada à minha seleção';
        } else {
          if (status) status.textContent = 'Esta obra já está na sua seleção.';
        }
      });
    }

    if (floatingSelection) {
      floatingSelection.addEventListener('click', renderSelectionDrawer);
    }

    document.addEventListener('click', function (event) {
      const removeButton = event.target.closest('[data-remove-selection]');
      if (!removeButton) return;

      const id = removeButton.dataset.removeSelection;
      const selection = getSelection().filter(function (item) {
        return item.id !== id;
      });

      saveSelection(selection);
      updateFloatingSelection();
      renderSelectionDrawer();
    });

    if (form) {
      form.addEventListener('submit', function () {
        const comment = commentField ? commentField.value : '';
        const nameInput = form.querySelector('[name="contact[name]"]');
        const emailInput = form.querySelector('[name="contact[email]"]');
        const phoneInput = form.querySelector('[name="contact[phone]"]');

        const name = nameInput ? nameInput.value : '';
        const email = emailInput ? emailInput.value : '';
        const phone = phoneInput ? phoneInput.value : '';

        let artworkBlock = '';

        if (currentMode === 'selection') {
          const selection = getSelection();

          artworkBlock = [
            'Consulta de obras selecionadas — José Paulo de Latorre',
            '',
            'Obras selecionadas:',
            '',
            selection.map(function (artwork, index) {
              return (index + 1) + '. ' + formatArtwork(artwork);
            }).join('\n\n')
          ].join('\n');
        } else if (currentArtwork) {
          artworkBlock = [
            'Consulta de obra — José Paulo de Latorre',
            '',
            formatArtwork(currentArtwork)
          ].join('\n');
        }

        const fullBody = [
          artworkBlock,
          '',
          'Mensagem do visitante:',
          'Estou interessado nesta obra.',
          '',
          'Nome: ' + name,
          'E-mail: ' + email,
          'Telefone: ' + phone,
          'Comentário: ' + comment
        ].join('\n');

        if (bodyField) {
          bodyField.value = fullBody;
        }
      });
    }

    updateFloatingSelection();
  });
})();
